var map = {
	"./anahuac_es.json": 117,
	"./ilernia_en.json": 118,
	"./ilernia_es.json": 119,
	"./ilernia_por.json": 120,
	"./puc_es.json": 121,
	"./pucv_es.json": 122,
	"./uaysen_es.json": 123,
	"./unab_es.json": 124,
	"./upc_es.json": 125,
	"./uplanner_en.json": 126,
	"./uplanner_es.json": 127,
	"./uplanner_por.json": 128
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 116;



//////////////////
// WEBPACK FOOTER
// ./src/lang ^\.\/.*\.json$
// module id = 116
// module chunks = 0